<template>
  <div class="container-fluid activity-page-wrapper">
    <div class="row">
      <div class="col-md-12">
        <div class="section">
          <div class="section-content padding-top-20">
            <CalendarActivityHeader v-if="activityDataFetchedSuccessfully" :activityId="playerActivityId"
              :session-type="activityInfo.type" :activity-info="activityInfo" :isDashboard="isDashboard" />

            <CalendarActivityTabs v-if="activityDataFetchedSuccessfully" :summary="activitySummary"
              :current-metric="calendarActivityselectedMetric" :change-selected-metric="changeSelectedMetric" :account="account"/>

            <ActivityCharts v-if="activityDataFetchedSuccessfully" :data="activityStats" :summary="activitySummary"
              :activity-info="activityInfo" :current-metric="calendarActivityselectedMetric"
              :hr-selected-unit="hrSelectedUnit" :hr-chart-unit="hrChartUnit" :distance-chart-unit="distanceChartUnit"
              :change-hr-chart-unit="changeHrChartUnit" :change-distance-chart-unit="changeDistanceChartUnit"
              :segments="segments" :filtered-segments="filteredSegments"
              :create-activity-segment="createActivitySegment" :delete-segment="deleteSegment"
              :player-activity-id="playerActivityId" :add-to-filtered-segments="addToFilteredSegments"
              :remove-from-filtered-segments="removeFromFilteredSegments"
              :select-deselect-all-segments="selectDeselectAllSegments"
              :fetch-more-precise-activity-data="fetchMorePreciseActivityData" :mediumPreciseChartDataHrPercentage="mediumPreciseChartDataHrPercentage
                " :mediumPreciseChartDataHrBPM="mediumPreciseChartDataHrBPM"
              :highPreciseChartDataHrBPM="highPreciseChartDataHrBPM" :highPreciseChartDataHrPercentage="highPreciseChartDataHrPercentage
                " :highestPreciseChartDataHrBPM="highestPreciseChartDataHrBPM" :highestPreciseChartDataHrPercentage="highestPreciseChartDataHrPercentage
                  " :mediumPreciseChartDataAP="mediumPreciseChartDataAP" :highPreciseChartDataAP="highPreciseChartDataAP"
              :highestPreciseChartDataAP="highestPreciseChartDataAP" :account="account"/>
            <PlayerStatsTables key="segments" v-if="activityDataFetchedSuccessfully" :data="activityStats"
              :activity-info="activityInfo" :current-metric="calendarActivityselectedMetric"
              :change-hr-unit="changeHrUnit" :change-avg-hr-unit="changeAvgHrUnit" :change-top-hr-unit="changeTopHrUnit"
              :change-ap-zones-unit="changeApZonesUnit" :change-workload-zones-unit="changeWorkloadZonesUnit"
              :change-distance-zones-unit="changeDistanceZonesUnit" :avg-hr-selected-unit="avgHrSelectedUnit"
              :top-hr-selected-unit="topHrSelectedUnit" :ap-zones-selected-unit="apZonesSelectedUnit"
              :workload-zones-selected-unit="workloadZonesSelectedUnit"
              :distance-zones-selected-unit="distanceZonesSelectedUnit" :stats-segment="statsSegment" :account="account"/>

            <TimelineChart :data="timelineChartData" :current-metric="calendarActivityselectedMetric"
              :account="account" />

            <DescAttachmentDel v-if="
              activityDataFetchedSuccessfully &&
              activityInfo.type === 'INDIVIDUAL' &&
              !isDashboard
            " :attachments="activityAttachments" :activityId="playerActivityId" :session-type="activityInfo.type"
              :description="description" :updateActivityDescription="updateActivityDescription"
              :activity-info="activityInfo" :delete-activity="deleteActivity" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SESSION_TYPES, ACTIVITY_STATUS } from "@/constants/SessionConsts"
import { TOASTER_ERROR } from "@/common/events.types"
import CalendarActivityHeader from "@/components/calendar-activity/CalendarActivityHeader"
import CalendarActivityTabs from "@/components/calendar-activity/CalendarActivityTabs"
import ActivityCharts from "@/components/calendar-activity/ActivityCharts"
import PlayerStatsTables from "@/components/calendar-activity/PlayerStatsTables"
import * as action from "@/store/action.types"
import { mapActions, mapGetters } from "vuex"
import TimelineChart from "@/components/calendar-activity/TimelineChart"
import DescAttachmentDel from "@/components/calendar-activity/DescAttachmentDel"

export default {
  name: "CalendarActivityContainer",
  computed: {
    ...mapGetters([
      "activityInfo",
      "activityStats",
      "activitySummary",
      "description",
      "activityAttachments",
      "playerActivityId",
      "activityDataFetchedSuccessfully",
      "calendarActivityselectedMetric",
      "hrSelectedUnit",
      "avgHrSelectedUnit",
      "topHrSelectedUnit",
      "apZonesSelectedUnit",
      "workloadZonesSelectedUnit",
      "distanceZonesSelectedUnit",
      "hrChartUnit",
      "distanceChartUnit",
      "segments",
      "filteredSegments",
      "statsSegment",
      "mediumPreciseChartDataHrPercentage",
      "mediumPreciseChartDataHrBPM",
      "highPreciseChartDataHrBPM",
      "highPreciseChartDataHrPercentage",
      "highestPreciseChartDataHrBPM",
      "highestPreciseChartDataHrPercentage",
      "mediumPreciseChartDataAP",
      "highPreciseChartDataAP",
      "highestPreciseChartDataAP",
      "activityNotFound",
      "activityDeleted",
      "timelineChartData",
      "account",
      "currentMetric",
    ]),
  },
  data() {
    return {
      sessionTypes: SESSION_TYPES,
    }
  },
  props: {
    isDashboard: {
      type: Boolean,
      required: false,
      default: () => false
    },
    dashboardLastActivityData: {
      type: Object,
      required: false,
      default: () => { }
    }
  },
  mounted() {
    if (this.isDashboard) {
      this.cacheDashboardActivityData(this.dashboardLastActivityData);
    }
    else {
      this.fetchCalendarActivityData({
        activityId: this.$route.params.activityId,
      })
    }
  },
  destroyed() {
    this.destroyCalendarActivityData()
  },
  methods: {
    ...mapActions({
      fetchCalendarActivityData: action.FETCH_CALENDAR_ACTIVITY_DATA,
      cacheDashboardActivityData: action.CACHE_DASHBOARD_ACTIVITY_DATA,
      changeSelectedMetric: action.CHANGE_CALENDAR_ACTIVITY_METRIC,
      changeHrUnit: action.CHANGE_HR_SELECTED_UNIT,
      changeAvgHrUnit: action.CHANGE_AVG_HR_SELECTED_UNIT,
      changeTopHrUnit: action.CHANGE_TOP_HR_SELECTED_UNIT,
      changeApZonesUnit: action.CHANGE_AP_ZONES_SELECTED_UNIT,
      changeWorkloadZonesUnit: action.CHANGE_WORKLOAD_ZONES_SELECTED_UNIT,
      changeDistanceZonesUnit: action.CHANGE_DISTANCE_ZONES_SELECTED_UNIT,
      changeHrChartUnit: action.CHANGE_HR_CHART_UNIT,
      changeDistanceChartUnit: action.CHANGE_DISTANCE_CHART_UNIT,
      destroyCalendarActivityData: action.DESTROY_ACTIVITY_DATA,
      updateActivityDescription: action.CHANGE_ACTIVITY_DESCRIPTION,
      deleteActivity: action.DELETE_ACTIVITY,
      fetchCalendarSegments: action.FETCH_ACTIVITY_SELECTIONS,
      createActivitySegment: action.CREATE_ACTIVITY_SEGMENT,
      deleteSegment: action.DELETE_ACTIVITY_SEGMENT,
      removeFromFilteredSegments: action.REMOVE_FROM_FILTERED_SEGMENT,
      addToFilteredSegments: action.ADD_TO_FILTERED_SEGMENT,
      selectDeselectAllSegments: action.SELECT_DESELECT_ALL_SEGMENT,
      selectStatsTableSegment: action.SELECT_STATS_TABLE_SEGMENT,
      getStatsSegmentsData: action.FETCH_STATS_TABLE_SEGMENTS,
      fetchMorePreciseActivityData: action.FETCH_MORE_PRECISE_ACTIVITY_DATA,
    }),
    checkActivityStatus() {
      if (this.activityInfo) {
        switch (this.activityInfo.status) {
          case ACTIVITY_STATUS.INVALID:
            this.$eventHub.$emit(TOASTER_ERROR, {
              message: this.$t(
                "CALENDAR_ACTIVITY.toastMessages.missingInvalidData"
              ),
            })

            break
          case ACTIVITY_STATUS.NOT_SYNCED:
            // this.$eventHub.$emit(TOASTER_ERROR, {
            //   message: this.$t("CALENDAR_ACTIVITY.toastMessages.notSync"),
            // })
            if (this.activityInfo.type === "INDIVIDUAL") {
              this.$eventHub.$emit(TOASTER_ERROR, {
                message: this.$t("CALENDAR_ACTIVITY.toastMessages.notSyncPMA"),
              })
            } else {
              this.$eventHub.$emit(TOASTER_ERROR, {
                message: this.$t("CALENDAR_ACTIVITY.toastMessages.notSyncCMA"),
              })
            }

            break
          case ACTIVITY_STATUS.NOT_PROCESSED:
            this.$eventHub.$emit(TOASTER_ERROR, {
              message: this.$t("CALENDAR_ACTIVITY.toastMessages.dataProcessed"),
            })

            break
          case ACTIVITY_STATUS.FAILED:
            this.$eventHub.$emit(TOASTER_ERROR, {
              message: this.$t(
                "CALENDAR_ACTIVITY.toastMessages.processingDataError"
              ),
            })

            break
          case ACTIVITY_STATUS.BELT_NOT_WORN:
            this.$eventHub.$emit(TOASTER_ERROR, {
              message: this.$t("CALENDAR_ACTIVITY.toastMessages.beltNotWorn"),
            })

            break
          case ACTIVITY_STATUS.PROCESSED:
            break
        }
      }
    },
  },
  watch: {
    activityInfo() {
      this.checkActivityStatus()
    },
    activityNotFound(newVal) {
      if (newVal) {
        this.$router.push("/")
        this.$eventHub.$emit(TOASTER_ERROR, {
          message: this.$t(
            "CALENDAR_ACTIVITY.toastMessages.unauthorizedAccess"
          ),
        })
      }
    },
    dashboardLastActivityData(newVal) {
      this.cacheDashboardActivityData(newVal);
    },
    activityDeleted(newVal) {
      if (newVal) {
        this.$eventHub.$emit(TOASTER_ERROR, {
          message: this.$t("CALENDAR_ACTIVITY.toastMessages.sessionDeleted"),
        })
        setTimeout(() => {
          this.$router.push("/calendar")
        }, 2000)
      }
    },
    calendarActivityselectedMetric() {
      if (
        (this.calendarActivityselectedMetric === "AP" &&
          this.activityStats.AP.sensorError) ||
        ((this.calendarActivityselectedMetric === "DISTANCE" ||
          this.calendarActivityselectedMetric === "WORKLOAD") &&
          this.activityStats.DISTANCE.sensorError)
      ) {
        this.$eventHub.$emit(TOASTER_ERROR, {
          message: this.$t("CALENDAR_ACTIVITY.playerStatsTables.sensorError"),
        })
      }
    },
  },
  components: {
    CalendarActivityHeader,
    CalendarActivityTabs,
    ActivityCharts,
    PlayerStatsTables,
    TimelineChart,
    DescAttachmentDel,
  },
}
</script>
